<template>
  <div>
    <v-row>
      <v-col>
        <span
          class="text-md-h6 text-lg-h6 text-lg-left text-md-left text-center title"
          >{{ pageTitle }}</span
        >
      </v-col>
      <v-col v-if="hasBackButton" class="text-right">
        <v-btn text @click="back()"> voltar </v-btn>
      </v-col>
      <v-col v-if="hasClose" class="text-right">
        <span class="icon-close close" @click="$emit('close', false)"></span>
      </v-col>
    </v-row>
    <v-divider />
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String
    },
    hasBackButton: {
      type: Boolean,
      default: true
    },
    hasClose: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async back() {
      if (this.$route.query.user_gfs_token) {
        await this.$store.dispatch(`$_auth/logout`);
        this.$store.commit("$_auth/DELETE_ME_AUTHENTICATED");
        this.$router.push("/autenticacao");
      } else this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.close {
  cursor: pointer;
}
</style>
